import script from "./AppPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./AppPopup.vue?vue&type=script&setup=true&lang=js"

import "./AppPopup.vue?vue&type=style&index=0&id=4a645aa5&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a645aa5"]])

export default __exports__